import type {Schemas} from 'api/dto.generated';
import type {Column} from '../types';

export const mapAvailableColumn = (
  dto: Schemas.Column,
  isWorkType?: boolean,
): Column => {
  return {
    ...dto,
    codelistId: dto.codelistId as Schemas.CodelistDto['id'],
    workColumn: isWorkType,
  };
};
